/**
 * PWA Repair Helper (iter100)
 *
 * Pulisce cache HTTP, unregistra Service Workers, cancella caches API,
 * localStorage/sessionStorage (tranne chiavi essenziali) e ricarica.
 *
 * Usato in due punti:
 *   - RootErrorBoundary (fallback quando la pagina crasha)
 *   - AdminLayout / LoginPage (pulsante "Ripara app" sempre disponibile)
 *
 * Non tocca DB o cookie di sessione (l'auth sopravvive al repair).
 */

// Chiavi da PRESERVARE nel localStorage (preferenze utente non critiche
// per la sessione ma utili). Tutto il resto viene cancellato.
const PRESERVE_KEYS = [];

export async function repairPwaAndReload() {
  const results = { sw: 0, caches: 0, storage_keys_cleared: 0, errors: [] };

  // 1) Unregister service workers
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        try {
          await r.unregister();
          results.sw += 1;
        } catch (e) {
          results.errors.push(String(e));
        }
      }
    }
  } catch (e) {
    results.errors.push(String(e));
  }

  // 2) Clear all Cache API entries
  try {
    if (window.caches) {
      const keys = await window.caches.keys();
      for (const k of keys) {
        try {
          await window.caches.delete(k);
          results.caches += 1;
        } catch (e) {
          results.errors.push(String(e));
        }
      }
    }
  } catch (e) {
    results.errors.push(String(e));
  }

  // 3) Clear localStorage (tranne PRESERVE_KEYS) — molti bug persistenti
  //    derivano da state stantio salvato qui (layout menu, cache clienti...)
  try {
    if (window.localStorage) {
      const preserved = {};
      for (const k of PRESERVE_KEYS) {
        const v = window.localStorage.getItem(k);
        if (v !== null) preserved[k] = v;
      }
      const total = window.localStorage.length;
      window.localStorage.clear();
      for (const [k, v] of Object.entries(preserved)) {
        window.localStorage.setItem(k, v);
      }
      results.storage_keys_cleared += total;
    }
  } catch (e) {
    results.errors.push(String(e));
  }

  // 4) Clear sessionStorage
  try {
    if (window.sessionStorage) {
      window.sessionStorage.clear();
    }
  } catch (e) {
    results.errors.push(String(e));
  }

  // 5) Hard reload: bypass HTTP cache. Aggiungiamo un query param di
  //    cache-busting per forzare il browser a riscaricare index.html.
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('_repair', String(Date.now()));
    window.location.replace(url.toString());
  } catch (_) {
    try {
      window.location.reload(true);
    } catch (_e) {
      window.location.reload();
    }
  }
  return results;
}
